import React from 'react';
import CompanyLogo from '../../content/CompanyLogo';
import CartToggle from '../CartToggle';

export const HeaderTestId = 'header-frameworkd';
type HeaderProps = {
  logoText: string;
  logoPublicId?: string;
};

const Header: React.FC<HeaderProps> = ({
  logoText,
  logoPublicId,
}: HeaderProps) => {
  return (
    <div
      className="flex flex-row md:items-center md:justify-center"
      data-testid={HeaderTestId}
    >
      <div className="pl-4 py-4 justify-self-start md:justify-self-center">
        <CompanyLogo logoText={logoText} logoPublicId={logoPublicId} />
      </div>
      <div className="block md:hidden justify-self-end">
        <CartToggle />
      </div>
    </div>
  );
};

export default Header;
